module.exports = __webpack_public_path__ + "img/pop_bg.3fc988b3.png";